module.exports = __webpack_public_path__ + "img/1280x720-Christmas.65a8de8b.jpg";